<template>

  <div :class="{'inp': true}">
    <label v-if="label">{{ label }}</label>

    <div class="input-wrapper">
      <input
        :class="{'is-error': error}"
        :placeholder="placeholder"
        v-model="edited_text"
        :name="name"
        :id="id"
        ref="elInput"
        :autocomplete="autocomplete"
        :maxlength="maxLength"
        @focus="focus"
        @blur="blur"
        @keypress="keypress"
        @keyup="keyup"
        :type="showPassword ? 'text' : type"
        :data-type="type"
        :data-test="locator"/>
      <button
        v-if="type === 'password'"
        type="button"
        class="password-toggle"
        @click="showPassword = !showPassword"
      >
        <img loading="lazy"
          :src="showPassword ? visibilityIcon : visibilityOffIcon"
          alt=""
          width="24"
          height="24"
        />
      </button>
    </div>
    <span class="error" v-if="error" :data-test="error">{{ $t(`${error}`)  }}</span>

  </div>

</template>


<script setup lang="ts">
import visibilityIcon from '@/assets/icons/source/used/visibility.svg'
import visibilityOffIcon from '@/assets/icons/source/used/visibility_off.svg'

interface PageProps {
  label?: string,
  text?: string,
  name?: string,
  pattern?: string,
  id?: string | null,
  type?: string,
  autocomplete?: string,
  placeholder?: string,
  error?: string,
  timeout?: number,
  focusOnMount?: boolean,
  locator?: string,
  maxLength?: number,
}

const props = withDefaults(defineProps<PageProps>(), {
  label: '',
  text: '',
  name: '',
  pattern: 'text',
  id: null,
  type: 'text',
  autocomplete: 'on',
  placeholder: '',
  error: '',
  timeout: 0,
  focusOnMount: false,
  locator: '',
  maxLength: 500,
})
 
const emits = defineEmits(['change:text', 'blur', 'focus']);

const elInput = ref(null);
const edited_text = ref(props.text);
const timeout = ref(null);

const showPassword = ref(false);

 
const keypress = (e: KeyboardEvent) => {
  // e.stopPropagation();
}

const keyup = (e: KeyboardEvent) => {
  // e.stopPropagation();
}


const focus = () => {
  emits('focus', edited_text)
}

const blur = () => {
  emits('blur', edited_text)
}

watch(edited_text, (val) => {

  if(timeout.value)
    clearTimeout(timeout.value);

  timeout.value = setTimeout(() => {
    emits('change:text', val)
  }, props.timeout);
}, { immediate: true });


watch(() => props.text, (val) => {
  if (val !== edited_text.value) {
    edited_text.value = val;
  }
}, { immediate: true });


onMounted(() => {
  if(props.focusOnMount){
    elInput.value.focus();
  }
});

</script>
   

<style scoped>

  input {
    width: 100%;
    height: 40px;
    padding: 0 16px;
  }

  input:focus{
    outline: 1px solid #008957;
  }

  input.is-error{
    outline: 1px solid #D25B50;
  }

  input:focus{
    outline: 1px solid #008957;
  }

  input.is-error{
    outline: 1px solid #D25B50;
  }

  input::-ms-reveal,
  input::-ms-clear {
    display: none;
  }

  .inp{
    margin-bottom: 0.5rem;

    width: 100%;
  }
  .error{
    color: #D25B50;
    font-size: 14px;

    width: 100%;
    margin-bottom: -16px;
    position: relative;
  }
 
  .input-wrapper {
    position: relative;
    display: flex;
    align-items: center;
    margin-top: 6px;
  }

  input[data-type="password"] {
    padding-right: 40px;
  }

  .password-toggle {
    position: absolute;
    right: 12px;
    top: 50%;
    transform: translateY(-50%);
    background: none;
    border: none;
    cursor: pointer;
    width: 24px;
    height: 24px;
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 0;
  }

</style>
